<hr *ngIf="isFooter" aria-hidden="true">
<div
  tabindex="0"
  class="item-container"
  (click)="handleInteraction()"
  (keyup.enter)="handleInteraction()"
  [attr.aria-label]="label"
  role="button"
>
  <div [ngClass]="isAwareness ? 'left-items-header' : 'left-items'" aria-hidden="true">
    <mat-icon
      *ngIf="haveIcon && !iconOnRight && !isAwareness"
      class="side-nav-icon"
    >
      {{icon}}
    </mat-icon>
    <mat-icon
      *ngIf="haveSvg && !iconOnRight"
      [svgIcon]="icon"
      class="side-nav-icon"
    >
    </mat-icon>
    <ng-container *ngIf="isAwareness; else isLabel">
      <div class="provider">
        <div class="provider-info">
          <div class="item-label" aria-label="Profile name with sub menu">{{ label }}</div>
          <iris-icon
            *ngIf="haveIcon"
            [name]="icon"
            [usage]="iconUsageTypes.STAND_ALONE"
            [color]="iconColors.BRAND1"
            [size]="iconSizes.MD"
          ></iris-icon>
        </div>
        <div *ngIf="status" class="item-status" data-test="new-clients-status" aria-hidden="true">{{ status }}</div>
      </div>
    </ng-container>
    <ng-template #isLabel>
      <div class="item-label">{{ label }}</div>
    </ng-template>
  </div>
  <div 
    *ngIf="badge" class="item-badge" 
    aria-hidden="true" 
    data-test="item-badge"
  >
    {{ badge }}
  </div>
  <mat-icon [svgIcon]="icon" *ngIf="haveSvg && iconOnRight" aria-hidden="true"></mat-icon>
</div>
<ng-content *ngIf="showSubMenu"></ng-content>
